import { render, staticRenderFns } from "./EditHistory.vue?vue&type=template&id=eb2e6ef4&scoped=true"
import script from "./EditHistory.vue?vue&type=script&lang=js"
export * from "./EditHistory.vue?vue&type=script&lang=js"
import style0 from "./EditHistory.vue?vue&type=style&index=0&id=eb2e6ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2e6ef4",
  null
  
)

export default component.exports